import { __module as r } from "./index779.js";
var f = r.exports, o;
function m() {
  return o ? r.exports : (o = 1, (function(s, u) {
    (function(n, e) {
      s.exports = e();
    })(f, (function() {
      return function(n, e) {
        e.prototype.isSameOrAfter = function(t, i) {
          return this.isSame(t, i) || this.isAfter(t, i);
        };
      };
    }));
  })(r), r.exports);
}
export {
  m as __require
};
